import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

/**
 * WebsocketService — DISABLED.
 *
 * The realtime WebSocket connection to the Workerman ChatServer has been disabled.
 *
 * This service is intentionally kept as a no-op stub so that every consumer
 * (chatbox, notification service, notification popover, specs) keeps compiling
 * and running without ever opening a socket connection.
 *
 * - connect()/disconnect()/close() are no-ops (no WebSocket is ever created).
 * - send()/sendChat()/sendNotification() return false (message dropped).
 * - isOpen() returns false.
 * - messages$/chat$/notifications$ never emit.
 * - connected$ reports false (disabled / disconnected).
 */
@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  /** Connection status stream — always false while websocket is disabled. */
  private statusSubject = new BehaviorSubject<boolean>(false);
  public connected$: Observable<boolean> = this.statusSubject.asObservable();

  /** Message streams — never emit while disabled. */
  private messageSubject = new Subject<any>();
  public messages$: Observable<any> = this.messageSubject.asObservable();

  private chatSubject = new Subject<any>();
  public chat$: Observable<any> = this.chatSubject.asObservable();

  private notifSubject = new Subject<any>();
  public notifications$: Observable<any> = this.notifSubject.asObservable();

  constructor() { }

  /** No-op: websocket is disabled, no connection is opened. Safe to call multiple times. */
  connect(data: any): void {
    console.warn('[WS] websocket disabled; connect() ignored', data);
  }

  /** No-op: websocket is disabled. */
  disconnect(): void { }

  /** Back-compat alias (old code called close()). */
  close(): void {
    this.disconnect();
  }

  /** Always false: no socket is ever open while websocket is disabled. */
  isOpen(): boolean {
    return false;
  }

  /** Always false: message dropped because websocket is disabled. */
  send(data: any): boolean {
    console.warn('[WS] websocket disabled; send() dropped:', data);
    return false;
  }

  sendChat(sender: number, receiver: number, message: string): boolean {
    return this.send({ type: 'message', api: 'chat', sender, receiver, message });
  }

  sendNotification(payload: any): boolean {
    return this.send({ type: 'message', api: 'notification', ...payload });
  }
}

